import axios from "axios";

export const authenticateUser = (token, validationKey) => {
  const objToSend = {
    token: token,
  };
  if (validationKey) {
    objToSend.validationKey = validationKey;
  }
  return axios.post(`/api/Authenticate`, objToSend, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const downloadFile = (token, screenName) => {
  return axios.get(`api/campaign/complete/${token}`, {
    headers: {
      "content-type": "application/json",
      "token-screen-name": screenName,
    },
    responseType: "blob",
  });
};

export const getEnvironment = () => {
  return axios.get(`api/env`, {
    headers: {},
    responseType: "text",
  });
};

export const completeScreenAction = (token, data, screenName) => {
  return axios.post(`/api/Campaign/complete/${token}`, data, {
    headers: {
      "content-type": "application/json",
      "token-screen-name": screenName,
    },
  });
};

export const getToken = (token) => {
  return axios.get(`/api/Tokens/${token}`, {
    headers: {
      "content-type": "application/json",
    },
  });
};

export const sendImageToOcr = (file, ocrCount) => {
  const formData = new FormData();
  formData.append("identityDocument", file);

  return axios.post(`/api/Ocr`, formData, {
    headers: {
      "content-type": "multipart/form-data",
      "operation-count": ocrCount,
    },
  });
};

export const runSpecialRequest = (token) => {
  return axios.post(`/api/SpecialRequests/${token}`, {
    headers: {
      "content-type": "application/json",
    },
  });
};
